import { CurrentLabel, SheetLabel } from "@/types";

export const isFabricObject = (obj: fabric.Object): obj is fabric.Object => {
  return obj.name !== undefined && obj.type !== undefined;
};

export const validateProp = <T>(prop?: T): prop is T => {
  return prop !== undefined;
};

export const getCurrentLabelProps = (label: any) => {
  if (label.shape_id && Number(label.shape_id) === 1) label.shape_id = 10;

  const props = {
    label_name: !label.name ? label.label_name : "Missing name",
    title: label.title ? label.title : label.name,
    corners: label.corners,
    corner_radius: parseFloat(label.corner_radius),
    shape_id: Number(label.shape_id),
    label_id: Number(label.id),
    width: parseFloat(label.width),
    height: parseFloat(label.height),
  };

  return props;
};

export const getSheetLabelProps = (label: any) => {
  if (label.shape_id && Number(label.shape_id) === 1) label.shape_id = 10;

  const props = {
    label_name: label.name,
    title: label.title,
    corners: label.corners,
    corner_radius: parseFloat(label.corner_radius),
    shape_id: Number(label.shape_id),
    label_id: Number(label.label_id),
    width: parseFloat(label.width),
    height: parseFloat(label.height),
    bleed: Number(label.bleed),
    bleed_size: parseFloat(label.bleed_size),
    top_margin: parseFloat(label.top_margin),
    bottom_margin: parseFloat(label.bottom_margin),
    horizontal_spacing: parseFloat(label.horizontal_spacing),
    vertical_spacing: parseFloat(label.vertical_spacing),
    left_margin: parseFloat(label.left_margin),
    right_margin: parseFloat(label.right_margin),
    shape_title: label.shape_title,
    svg_id: Number(label.svg_id),
    mask_id: Number(label.mask_id),
    mask_url: label.mask?.file_url || label.mask_url || null,
    sheet_size_title: label.sheet_size_title,
    sheet_size_width: Number(label.sheet_size.width),
    sheet_size_height: Number(label.sheet_size.height),
    labels_per_sheet: Number(label.labels_per_sheet),
    labels_per_row: 0,
  };

  return props;
};

export const validateCurrentLabelProps = (props?: any): CurrentLabel => {
  if (!props) throw new Error("No properties provied for validating, mutations.ts");

  let bool = true;

  Object.keys(props).forEach((key) => {
    if (
      props[key as keyof CurrentLabel] === undefined ||
      Number.isNaN(props[key as keyof CurrentLabel])
    )
      bool = false;
  });

  if (!bool) {
    throw new Error("Error when validating keys of prop provided, mutations.ts");
  } else {
    const label: CurrentLabel = props;

    return label;
  }
};

export const validateSheetLabelProps = (props?: any): SheetLabel => {
  if (!props) throw new Error("No properties provied for validating, mutations.ts");

  let bool = true;

  Object.keys(props).forEach((key) => {
    if (
      props[key as keyof SheetLabel] === undefined ||
      Number.isNaN(props[key as keyof SheetLabel])
    )
      bool = false;
  });

  if (!bool) {
    throw new Error("Error when validating keys of prop provided, mutations.ts");
  } else {
    const label: SheetLabel = props;
    const sheet_width = label.sheet_size_width;
    const left_margin = label.left_margin;
    const right_margin = label.right_margin;
    const width = label.width;
    const horizontal_spacing = label.horizontal_spacing;

    label.labels_per_row = Math.round(
      (sheet_width - left_margin - right_margin) / (width + horizontal_spacing)
    );

    return label;
  }
};
